
























import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import {
  OPEN_SAVE_BEFORE_LEAVE_WIZARD_MODAL,
  SAVE_AS_DRAFT,
  SAVE_BEFORE_LEAVE_WIZARD_ROUTE_NAME,
  SET_OPEN_SAVE_BEFORE_LEAVE_WIZARD_MODAL,
  SET_SAVE_BEFORE_LEAVE_WIZARD_ROUTE_NAME,
} from '@/types/form.types';

@Component({})
export default class SaveBeforeLeaveWizardModal extends Vue {

  @Action(SAVE_AS_DRAFT, StoreNamespace.FORM) public saveAsDraft;

  @Mutation(SET_OPEN_SAVE_BEFORE_LEAVE_WIZARD_MODAL, StoreNamespace.FORM) public setOpenSaveBeforeLeaveWizardModal;
  @Mutation(SET_SAVE_BEFORE_LEAVE_WIZARD_ROUTE_NAME, StoreNamespace.FORM) public setSaveBeforeLeaveWizardRouteName;

  @Getter(OPEN_SAVE_BEFORE_LEAVE_WIZARD_MODAL, StoreNamespace.FORM) public openSaveBeforeLeaveWizardModal!: boolean;
  @Getter(SAVE_BEFORE_LEAVE_WIZARD_ROUTE_NAME, StoreNamespace.FORM) public saveBeforeLeaveWizardRouteName!: string;

  public closeDialog(): void {
    this.setOpenSaveBeforeLeaveWizardModal(false);
    this.setSaveBeforeLeaveWizardRouteName('');
  }

  public confirmDialog(): void {
    this.$router.push({ name: this.saveBeforeLeaveWizardRouteName });
    this.setOpenSaveBeforeLeaveWizardModal(false);
    this.setSaveBeforeLeaveWizardRouteName('');
  }

  public destroyed() {
    this.setOpenSaveBeforeLeaveWizardModal(false);
  }

}
